
/**
 * Billing frequency
 */
export type PlanResponseBillingCycle = typeof PlanResponseBillingCycle[keyof typeof PlanResponseBillingCycle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlanResponseBillingCycle = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  ONE_TIME: 'ONE_TIME',
} as const;
